<div class="form">
    <form [formGroup]="loginForm" *ngIf="loginMode" (ngSubmit)="signIn()">
        <div class="title">Please sign in</div>

        <app-alert />
        <div class="label">Email</div>
        <input type="email" required autofocus formControlName="email" class="field" maxlength="50">
        <div class="label">Password</div>
        <div class="password-input">
            <input [type]="passwordState.type" required formControlName="password" class="field" maxlength="50">
            <span class="password-toggle" (click)="passwordState.toggle()" [class.password-visible]="passwordState.visible"></span>
        </div>
        <div class="forgot-password">
            <span (click)="onForgotPassword()" class="link">Forgot your password?</span>
        </div>
        <button type="submit" [disabled]="!loginForm.valid || isLoading" class="button">
            <span [hidden]="isLoading">Sign in</span>
            <img src="../../../assets/img/spinner.svg" alt="Loading" [hidden]="!isLoading"/>
        </button>
        <div class="text-center" style="margin-top: 25px">
            <span routerLink="/signup" class="link important">Don't have an account yet?</span>
        </div>
    </form>
    <form [formGroup]="resetForm" *ngIf="!loginMode" (ngSubmit)="reset()">
        <div class="title">Reset password</div>

        <app-alert />
        <div class="label">Email</div>
        <input type="email" required autofocus formControlName="email" class="field" maxlength="50">
        <div>
            <div class="pull-right forgot-password">
                <span (click)="toLoginMode()" class="link">Cancel</span>
            </div>
        </div>
        <button type="submit" [disabled]="!resetForm.valid || isLoading" class="button">
            <span [hidden]="isLoading">Request password reset</span>
            <img src="../../../assets/img/spinner.svg" alt="Loading" [hidden]="!isLoading"/>
        </button>
    </form>
</div>
